module.exports = __webpack_public_path__ + "img/10.6fc00d5d.png";